import { Injectable } from '@angular/core';
import { Observable, from } from "rxjs";
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Assets, OtpVerifyInput } from '../../Class/Assets/assets';

export interface Dealer {
    id: number;
    organization_name: string;
    isSelected?: boolean; // Add this property if needed
}
export interface AssetsResponse {
    data: Dealer[];
}

@Injectable({
    providedIn: 'root'
})

export class AssetsService {
    private apiBaseUrl: string = environment.apiUrl;

    constructor(
        private http: HttpClient,
    ) { }


    Getmarket(): Observable<Assets> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json'})
        };
        return this.http.get(this.apiBaseUrl + "/api/assets/GetMarket", httpOptions).pipe(map(m => <Assets>m))
    };

    GetCategory(id: string): Observable<Assets> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        return this.http.get(`${this.apiBaseUrl}/api/assets/GetCategory/${id}`, httpOptions).pipe(map(m => <Assets>m))
    };


    GetSubCategory(id: string): Observable<Assets> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        return this.http.get(`${this.apiBaseUrl}/api/assets/GetsubCategory/${id}`, httpOptions).pipe(map(m => <Assets>m))
    };

    GetUom(): Observable<Assets> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        return this.http.get(`${this.apiBaseUrl}/api/assets/GetUomList`, httpOptions).pipe(map(m => <Assets>m))
    };

    GetCurrency(): Observable<Assets> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        return this.http.get(`${this.apiBaseUrl}/api/assets/GetCurrency`, httpOptions).pipe(map(m => <Assets>m))
    };

    GetProductCategory(): Observable<Assets> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        return this.http.get(`${this.apiBaseUrl}/api/assets/GetProductCategory`, httpOptions).pipe(map(m => <Assets>m))
    };

    GetProductSubCategory(id: string): Observable<Assets> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        return this.http.get(`${this.apiBaseUrl}/api/assets/GetProductSubCategory/${id}`, httpOptions)
            .pipe(map((res: any) => <Assets>res));  // Cast the response to the expected type 'Assets'
    }    

    GetCountry(): Observable<Assets> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        return this.http.get(`${this.apiBaseUrl}/api/assets/GetCountry`, httpOptions).pipe(map(m => <Assets>m))
    };

    GetIndustry(): Observable<Assets> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        return this.http.get(`${this.apiBaseUrl}/api/assets/GetIndustry`, httpOptions).pipe(map(m => <Assets>m))
    };

    SendOTP(mobile : string): Observable<Assets> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        return this.http.get(`${this.apiBaseUrl}/api/assets/SendOTPbeforeLogin/${mobile}`, httpOptions).pipe(map(m => <Assets>m))
    };

    ReSendOTP(mobile : string): Observable<Assets> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        return this.http.get(`${this.apiBaseUrl}/api/assets/ResendOtp/${mobile}`, httpOptions).pipe(map(m => <Assets>m))
    };

    OTPVerify(formData: FormData): Observable<OtpVerifyInput> {
        return this.http.post<OtpVerifyInput>(`${this.apiBaseUrl}/api/assets/OTPVerify`, formData)
          .pipe(map(m => <OtpVerifyInput>m));
    }

    GetHSNCode(): Observable<Assets> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        return this.http.get(`${this.apiBaseUrl}/api/assets/GetHSNCode`, httpOptions).pipe(map(m => <Assets>m))
    };

    GetallCategory(): Observable<Assets> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        return this.http.get(`${this.apiBaseUrl}/api/assets/GetAllCategory`, httpOptions).pipe(map(m => <Assets>m))
    };

    GetallBuyerTypes(): Observable<Assets> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        return this.http.get(`${this.apiBaseUrl}/api/assets/GetBuyerType`, httpOptions).pipe(map(m => <Assets>m))
    };


    GetLocation(user_id :number): Observable<Assets> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Accept': 'application/json'})
        };
        return this.http.get(`${this.apiBaseUrl}/api/assets/GetLocation/${user_id}`, httpOptions).pipe(map(m => <Assets>m))
    };

    Enquiry_Form(FormData: FormData): Observable<Assets> {

        FormData.append('ipaddress', localStorage.getItem('getip') || '0.0.0.0');
        FormData.append('browser_ver', localStorage.getItem('getbrowser') || '-');
        FormData.append('browser', localStorage.getItem('getbrowser_version') || '-');
        FormData.append('os', localStorage.getItem('getostype') || '-');

        const httpOptions = {
            headers: new HttpHeaders({ 'Accept': 'application/json' })
        };
        return this.http.post(`${this.apiBaseUrl}/api/assets/ContactEnquiry`,FormData, httpOptions).pipe(map(m => <Assets>m))
    };

    GetAllDealerDetail(): Observable<AssetsResponse> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        return this.http.get<AssetsResponse>(`${this.apiBaseUrl}/api/assets/GetAllDealerDetail`, httpOptions);
        // return this.http.get(`${this.apiBaseUrl}/api/assets/GetAllDealerDetail`, httpOptions).pipe(map(m => <Assets>m))
    };

    //location in dealer
    GetallCountry(): Observable<Assets> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        return this.http.get(`${this.apiBaseUrl}/api/assets/GetAllCountry`, httpOptions).pipe(map(m => <Assets>m))
    };


     GetallCategoryProduct(): Observable<Assets> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        return this.http.get(`${this.apiBaseUrl}/api/assets/GetallCategoryProduct`, httpOptions).pipe(map(m => <Assets>m))
    };

}
